import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import cardBg from '../../assets/images/card_bg.png';

const StyledContainer = styled.div<{ $compact?: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 16px;
	justify-content: space-between;
	width: 100%;
	padding: ${({ $compact }) => ($compact ? '16px 20px' : '20px')};
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	background-image: url(${cardBg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
`;

const StyledTopContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledBalanceValue = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 700;
		font-size: 16px;
		color: #ffffff;
	}

	img {
		opacity: 0.5;
	}
`;

const StyledBottomContainer = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	align-items: center;
	gap: 10px;

	${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.5;
		transition: opacity 0.3s ease;
	}
`;

const StyledCopyButton = styled.div`
	height: 14px;
	opacity: 0.5;
	transition: opacity 0.3s ease;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledCardNumberContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	cursor: pointer;

	&:hover {
		${Text} {
			opacity: 1;
		}

		${StyledCopyButton} {
			opacity: 1;
		}
	}
`;

export {
	StyledBalanceValue,
	StyledBottomContainer,
	StyledCardNumberContainer,
	StyledContainer,
	StyledCopyButton,
	StyledTopContainer,
};
